// Rich template + SLA config for the new-incident wizard.
// Frontend-only static config — backend stores severity + parties arrays plain.

export const WIZARD_TEMPLATES = [
  {
    value: "jis",
    label: "JIS Sequence Error",
    icon: "RefreshCw",
    sev: "s1",
    description: "Just-in-Sequence delivery offset or mismatch",
    parties: ["OEM Production", "JIS Center", "Tier 1"],
  },
  {
    value: "stoppage",
    label: "Line Stoppage — Active",
    icon: "OctagonAlert",
    sev: "s1",
    description: "Production line is currently stopped",
    parties: ["OEM Production", "Tier 1", "4PL"],
  },
  {
    value: "quality",
    label: "Quality Lock",
    icon: "ShieldAlert",
    sev: "s2",
    description: "Quality block / sorting required at dock",
    parties: ["OEM Quality", "Tier 1 Quality", "Sorting SP"],
  },
  {
    value: "transport",
    label: "Inbound Transport Delay",
    icon: "TruckIcon",
    sev: "s2",
    description: "Carrier ETA missed, shipment in transit",
    parties: ["OEM Logistics", "Tier 1", "Road Carrier"],
  },
  {
    value: "packaging",
    label: "Packaging Shortage",
    icon: "PackageX",
    sev: "s3",
    description: "Returnable container / dunnage shortfall",
    parties: ["OEM", "Tier 1", "Pkg. Operator"],
  },
  {
    value: "customs",
    label: "Customs / Border Hold",
    icon: "Globe",
    sev: "s2",
    description: "Shipment held by customs / cross-border issue",
    parties: ["OEM", "Tier 1", "Customs Broker"],
  },
  {
    value: "damage",
    label: "Warehouse Damage / Loss",
    icon: "BoxIcon",
    sev: "s3",
    description: "Goods damaged in handling or storage",
    parties: ["OEM / Tier 1", "3PL Warehouse", "Insurance"],
  },
  {
    value: "material",
    label: "Raw Material Shortage",
    icon: "Layers",
    sev: "s2",
    description: "Upstream material supply gap",
    parties: ["Tier 1", "Tier 2", "Raw Material Supplier"],
  },
];

// SLA per severity (used by the Review step's commitment card)
export const SLA_BY_SEV = {
  s1: { ack: "15 min", resolve: "4 h", color: "#E24B4A", label: "S1 · Line Stop" },
  s2: { ack: "30 min", resolve: "8 h", color: "#f39c12", label: "S2 · Critical" },
  s3: { ack: "1 h", resolve: "24 h", color: "#185FA5", label: "S3 · High" },
  s4: { ack: "4 h", resolve: "48 h", color: "#9198b0", label: "S4 · Standard" },
};

export const SEVERITY_OPTIONS = [
  { value: "s1", label: "S1 · Line Stop" },
  { value: "s2", label: "S2 · Critical" },
  { value: "s3", label: "S3 · High" },
  { value: "s4", label: "S4 · Standard" },
];

// Color cue for the "layer" tag on linked-party cards (matches existing supply-chain palette)
export const PARTY_LAYER_COLOR = {
  OEM: "#27ae60",
  "OEM Production": "#27ae60",
  "OEM Quality": "#27ae60",
  "OEM Logistics": "#27ae60",
  "JIS Center": "#5fa3e3",
  "Tier 1": "#185FA5",
  "Tier 1 Quality": "#185FA5",
  "Tier 2": "#c89adb",
  "Raw Material Supplier": "#c89adb",
  "4PL": "#f3b14a",
  "Road Carrier": "#f3b14a",
  "Air Carrier": "#f3b14a",
  "Freight Forwarder": "#f3b14a",
  "Milk Run Carrier": "#f3b14a",
  "Pkg. Operator": "#9ec3ec",
  "Sorting SP": "#c89adb",
  "Customs Broker": "#9198b0",
  "Insurance": "#9198b0",
  "Measurement Lab": "#c89adb",
  "3PL Warehouse": "#f3b14a",
  "OEM / Tier 1": "#27ae60",
};
